import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import PlanList from "../../Components/PlanList";
import OperatingSystem from "../../Components/OperatingSystem";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import MinPlanPrice from "../../Components/MinPlanPrice";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function DedicatedServerMontreal() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Dedicated Server Montreal for High Performance & Security";
    sal();
  }, []);
  const handlePlanClick = () => {
      ScrollToPlans(".price-plan-section");
      };
  return (
    <>
      <Helmet>
        <title>Dedicated Server Montreal for High Performance & Security</title>
        <meta name="description" content="Dedicated Server Montreal Hosting Services with High Speed, Full Control, and 24/7 Support for Growing Businesses Worldwide with Enterprise Infrastructure" />
        <meta name="keywords" content="Dedicated Server Price, Server Montreal, Montreal Server, Dedicated Server Montreal" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/dedicated-server-montreal`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/dedicated-server-montreal`} />
        <meta property="og:title" content="Dedicated Servers Montreal: Secure, Scalable and Reliable" />
        <meta property="og:description" content="Select Dedicated Server Montreal for a secure, reliable solution that guarantees high performance & high uptime, customized to meet your business needs." />
      </Helmet>
      <div className="wordpress-hosting-banner about-banner pb-120 bg-dark">
        <div className="container">
            <div className="row g-4 align-items-center align-items-xxl-end">
                <div className="col-lg-7">
                    <div className="d-flex align-items-center gap-2">
                        <div className="w-3 h-3 rounded-circle bg-primary flex-shrink-0"></div>
                        <span className="d-block fw-semibold mb-0 text-primary">
                            Downtime to Uptime in a Second
                        </span>
                    </div>
                    <h1 className="mb-6 text-white">
                       Go to 'We’re Winning' With Dedicated Server Montreal
                    </h1>
                    <p className="text-white max-text-60 mb-8 text-opacity-75">
                        No more midnight worries or missed opportunities. Our dedicated server Montreal is engineered for businesses that can’t afford to lose any single client-offering 99.9% uptime and the performance your company deserves.
                    </p>
                    <div className="d-flex align-items-center flex-wrap gap-4">
                        <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-semibold rounded btn-height">
                            <span className="btn-arrow__text">
                                Free Trial
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                        <button onClick={handlePlanClick} className="btn btn-light btn-arrow btn-lg fs-14 fw-semibold rounded transition btn-height">
                              <span className="btn-arrow__text">
                                  Explore
                                  <span className="btn-arrow__icon">
                                      <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                              </span>
                          </button>
                      <MinPlanPrice category="customizeddmn" />
                    </div>
                    <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                </div>
                <div className="col-lg-5 ipad-mt">
                    <div className="about-banner__img">
                        <img src="images/from-why-is-my-site-down.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div className="pt-100 pb-100 cloud-hosting-points-section">
        <div className="pb-60">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-10 col-xl-8 text-center sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <span className="section-title style-bg fadeInUp">Zero Guesswork. Just Montreal.</span>
                        <h2 className="mb-0">
                            Out of Excuses, Out of Gambling: In with Montreal Servers
                        </h2>
                        <span className="d-inline-block fw-semibold text-primary mb-2">
                            
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4 g-md-0 feature-list">
                <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="feature-list__card border text-center">
                        <div className="mb-8">
                            <img src="/images/take-the-controls.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6 className="mb-5">
                            Take the Controls: It’s Your Game
                        </h6>
                        <p className="mb-0">
                            Ever felt stuck in your hosting? With our Canada dedicated server, you are your boss-ranging from your operating system to how your website runs.
                        </p>
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="feature-list__card border text-center">
                        <div className="mb-8">
                            <img src="/images/no-slow-speeds-just-10-Gbps.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6 className="mb-5">
                            No Slow Speeds: Just 10 Gbps Power
                        </h6>
                        <p className="mb-0">
                            Sick of sites that lag when it is necessary? Your apps and high-traffic sites stay seamless on our dedicated server Montreal, powered by flash.
                        </p>
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                    <div className="feature-list__card border text-center">
                        <div className="mb-8">
                            <img src="/images/be-the-admin.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6 className="mb-5">
                           Be the Admin, Not the Waitlist
                        </h6>
                        <p className="mb-0">
                            Why always settle for half-access, not full? With our dedicated server Montreal, you get admin rights-get what you want, ditch what you don’t.
                        </p>
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="600" data-sal-easing="ease-in-out-sine">
                    <div className="feature-list__card border text-center">
                        <div className="mb-8">
                            <img src="/images/all-set-no-worries.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6 className="mb-5">
                            All Set, No Worries: Tools That Work
                        </h6>
                        <p className="mb-0">
                            Everything your business needs, fully ready to roll-ranging from file access to databases. A Canada dedicated server gives you satisfaction.
                        </p>
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="700" data-sal-easing="ease-in-out-sine">
                    <div className="feature-list__card border text-center">
                        <div className="mb-8">
                            <img src="/images/rapid-setup-go-live-fast.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6 className="mb-5">
                            Rapid Setup: Go Live Fast in No Time
                        </h6>
                        <p className="mb-0">
                            Within 4 hours of placing your order, our in-stock server hardware is all set to go. We’ll set up your server with your OS & management panel.
                        </p>
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="800" data-sal-easing="ease-in-out-sine">
                    <div className="feature-list__card border text-center">
                        <div className="mb-8">
                            <img src="/images/the-fast-lane.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6 className="mb-5">
                           The Fast Lane Is Now Yours
                        </h6>
                        <p className="mb-0">
                          Tired of all other users’ site traffic always slowing you down? With our assets on your dedicated server Montreal, performance stays blazing fast.
                        </p>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <section className="price-plan-section pt-100 pb-100 position-relative">
        <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
        <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8">
                        <div className="text-center">
                            <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                            <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> You Just Call the Shots. We Power the Rest.</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PlanList category={'customizeddmn'}/>
      </section>
      <section className="service-area pt-100 pb-100">
            <div className="pb-40">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7">
                            <span className="section-title style-bg fadeInUp">Our Advantages</span>
                            <h2 className="mb-0" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200"
                                data-sal-easing="ease-in-out-sine">Go From ‘Chill Mode’ to ‘Beast Mode’ With Extra Perks</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row g-4">
                    <div className="col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="450" data-sal-delay="150" data-sal-easing="ease-in-out-sine">
                                <img className="service-figure-1" src="images/feature-shape-1.webp" alt="" />
                            <div className="card-body px-md-7 py-md-8">
                                <div className="row align-items-center g-4 d-grid">
                                    <div className="col-md-4">
                                        <img className="service-img" src="images/tap-in.-lock-power.webp" alt="" />
                                    </div>
                                    <div className="col-md-12">
                                        <h6 className="mb-4">Tap In. Lock Power. Vanish Lag.</h6>
                                        <p className="mb-5 pb-2">Are you all set to go from “ugh” to “omg”? Once you are in, our dedicated servers just kick out lag & lock in speed-so your site just enjoys.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="450" data-sal-delay="150" data-sal-easing="ease-in-out-sine">
                            <img className="service-figure-1" src="images/feature-shape-1.webp" alt="" />
                            <div className="card-body px-md-7 py-md-8">
                                <div className="row align-items-center g-4 d-grid">
                                    <div className="col-md-4">
                                        <img className="service-img" src="images/ctrl-alt-outrun.webp" alt="" />
                                    </div>
                                    <div className="col-md-12">
                                        <h6 className="mb-4">Ctrl + Alt + Outrun Everyone.</h6>
                                        <p className="mb-5 pb-2">Ignore all basic setups. With us, you get the genuine deal-where your business website doesn’t just run, but also outruns the basics with zero effort.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Turn Vibes Into Reliable Uptime.</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img className="small-service-img" src="images/turn-vibes-into-reliable.webp" alt="" />
                                    </div>
                                    <div>
                                        <p>Your energy is more than you think-your hosting should be too. Always keep the positive vibes online, 24/7.</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Your Site Deserves a Hype Engine.</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img className="small-service-img" src="images/your-site-deserves-a-hype.webp" alt="" />
                                    </div>
                                    <div>
                                        <p>You have always got content & all the struggle-now upgrade it with a engine that’s built to manage heat.</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Servers That Don’t Sleep, 24/7</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img className="small-service-img" src="images/servers-that-don’t-sleep.webp" alt="" />
                                    </div>
                                    <div>
                                        <p>Why stress about uptime when we’ve already got it secured? Sleep while our dedicated servers are live.</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Admin Access Is Just A Boot Away.</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img className="small-service-img" src="images/admin-access-is-just.webp" alt="" />
                                    </div>
                                    <div>
                                        <p>One single boot, one move, boom access. Your site hits high traffic with servers built for firepower.</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Don’t Host. Just Flex Seamlessly.</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img className="small-service-img" src="images/don’t-host-Just.webp" alt="" />
                                    </div>
                                    <div>
                                        <p>Hosting isn't only about being available-it’s also about getting your individual space.</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>If Spam Kills Vibes, We Revive 'Em.</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img className="small-service-img" src="images/if-spam-kills-vibes.webp" alt="" />
                                    </div>
                                    <div>
                                        <p>Spam? Blocked. Negative vibes? Gone. With our filters, your inbox always stays clean and spam-free.</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </section>
      <section className="feedback-2-area pt-100 pb-100 bg-dark position-relative z-1">
        <div className="container">
            <div className="row g-4 justify-content-xxl-between align-items-center">
                <div className="col-lg-6 col-xxl-5 order-lg-2">
                    <h2 className="text-white mb-4">
                        We Babysit Your Server So You Don’t Have To
                    </h2>
                    <p className="mb-8 text-white text-opacity-75">
                        Don’t sweat the tech stuff-we're just a message away. Our experts are available 24/7 to troubleshoot and vibe with your server demands.
                    </p>
                    <Link to="/about-us" className="btn btn-primary btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                        <span className="btn-arrow__text">
                            About Us
                            <span className="btn-arrow__icon">
                                <i className="fa-solid fa-arrow-right"></i>
                            </span>
                        </span>
                    </Link>
                </div>
                <div className="col-lg-6 order-lg-1 ipad-mt">
                    <div className="feedback-2-container">
                        <img alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" src="images/we-babysit-your-server.webp"></img>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <OperatingSystem/>
      <section className="simple-box-section pt-60 pb-100 responsive-pt-50">
      <div className="container">
        <div className="row">
            <div className="col-12">
                <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card-body px-6 pt-60 pb-60">
                        <div className="row justify-content-center">
                            <div className="col-md-11 col-lg-8 col-xl-8">
                                <div className="text-center">
                                  <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Built to Slay</span>
                                    <h4 className="mb-4">
                                        Why wait? Your server is all set to slay
                                    </h4>
                                    <p className="mb-6">
                                      Stop Struggling, Start Scaling: With Dedicated Server Montreal That Hits Different

                                    </p>
                                    <Link to="#" onClick={handlePlanClick}  className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded btn-height">
                                        <span className="d-inline-block me-1 flex-shrink-0">
                                            <i className="las la-comments"></i>
                                        </span>
                                        <span className="btn-arrow__text">
                                            Go Live Now
                                            <span className="btn-arrow__icon">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </section>
    </>
  );
}
